import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  InputAdornment
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useAuth } from 'react-oidc-context';
import appConfig from '../config/app';

const RMACheck = ({ onMessage, navigate }) => {
  const auth = useAuth();
  const [rmaNumber, setRmaNumber] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!rmaNumber.trim()) {
      onMessage('Please enter an RMA number', 'error');
      return;
    }

    setLoading(true);
    try {
      const token = auth.user?.access_token;
      const cognito_user_id = auth.user?.profile?.sub;

      const response = await fetch(`${appConfig.api.baseUrl}/rma/number/${rmaNumber.trim()}/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-Cognito-User-ID': cognito_user_id
        }
      });

      if (response.ok) {
        const result = await response.json();
        navigate(`/rma/${result.id}`);
        onMessage(`RMA ${rmaNumber} found`, 'success');
      } else if (response.status === 404) {
        onMessage(`RMA ${rmaNumber} not found`, 'error');
      } else {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch RMA');
      }
    } catch (error) {
      console.error('Error searching RMA:', error);
      onMessage(`Error searching RMA: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSearch} sx={{ width: '100%' }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Search and manage your existing RMA requests by their tracking number.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          fullWidth
          label="RMA Number"
          placeholder="e.g., 1234567890"
          value={rmaNumber}
          onChange={(e) => setRmaNumber(e.target.value)}
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
        <Button
          type="submit"
          variant="contained"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          disabled={loading}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 'bold',
            py: 1.2,
            boxShadow: 1
          }}
        >
          {loading ? 'Searching...' : 'Search RMA'}
        </Button>
      </Box>
    </Box>
  );
};

export default RMACheck;